<template>
    <div style="padding: 0 10px">
        <div style="text-align: left">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" @keydown.native.enter="submit">
                <el-form-item label="操作人">
                    <el-input maxlength='50' v-model="formInline.operatorName" placeholder="操作人" clearable
                        @clear="getList"></el-input>
                </el-form-item>
                <el-form-item label="任务类型">
                    <el-select v-model="formInline.businessType" placeholder="任务类型" @change="submit">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="导入" :value="0"></el-option>
                        <el-option label="导出" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务状态">
                    <el-select v-model="formInline.status" placeholder="任务状态" @change="submit">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="待处理" :value="0"></el-option>
                        <el-option label="处理中" :value="1"></el-option>
                        <el-option label="成功" :value="2"></el-option>
                        <el-option label="失败" :value="3"></el-option>
                        <el-option label="部分成功" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作时间">
                    <el-date-picker v-model="date" @change="dateChange" type="datetimerange"
                        :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button style="" type="primary" @click="submit">查询</el-button>
                    <el-button style="margin-left: 10px" @click="rest">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :hasHeader="false"
            :isPagination="query">
            <div slot="extend" slot-scope="{text, record}">
              <div class="ellipsis" :title="text">{{ text }}</div>
            </div>
            <div slot="action" slot-scope="{record}">
                <el-button @click="download(record)" type="text" v-if="record.status == 2 && record.businessType == 1" :disabled="userId != record.operatorId">下载导出数据</el-button>
                <el-button @click="download(record)" type="text" v-if="record.businessType == 0" :disabled="userId != record.operatorId">下载导入数据</el-button>
                <el-button style="color:red" type="text" v-if="record.status == 4" @click="downFailData(record)" :disabled="userId != record.operatorId">下载错误数据</el-button>
            </div>
        </WmsTable>
    </div>
</template>
  
<script>
import WmsTable from "@/components/WmsTable";
import { oneServiceTaskPage, oneServiceDownloadImportFailData, oneServiceDownloadExportData } from "@/apis/exportCenter"
import { columns } from "./data"
export default {
    title: '数据导出',
    name: "Export",
    components: { WmsTable },
    props: {},
    data() {
        return {
            formInline: {
              operatorName: undefined
            },
            date: '',
            columns,
            dataSource: [],
            query: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            userId: ''
        };
    },

    created() { },
    mounted() {
        this.userId = this.$store.getters.getAuthInfo.userId
        this.formInline.operatorName = this.$store.getters.getUserName
        this.getList()
    },

    methods: {
        submit() {
            this.query.current = 1
            this.getList()
        },
        rest() {
            this.date = null
            Object.keys(this.formInline).forEach(i => {
                this.formInline[i] = undefined
            });
            this.formInline.operatorName = this.$store.getters.getUserName
            this.query = {
                current: 1,
                pageSize: 10,
                total: 0
            }
            this.getList()
        },
        dateChange: function (date) {
            // console.log(val)
            if (!date) {
                this.date = null
                this.formInline.createStartTime = undefined
                this.formInline.createEndTime = undefined
                return
            }
            this.formInline.createStartTime = formatDate(date[0].getTime());
            this.formInline.createEndTime = formatDate(date[1].getTime());
            this.submit()


            function formatDate(value) {
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                let h = date.getHours();
                h = h < 10 ? "0" + h : h;
                let m = date.getMinutes();
                m = m < 10 ? "0" + m : m;
                let s = date.getSeconds();
                s = s < 10 ? "0" + s : s;
                return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
            };
        },
        pageChangeCall(payload) {
            const { current, pageSize } = payload;
            this.query.current = current;
            this.query.pageSize = pageSize;
            this.getList();
        },
        getList() {
            let params = {
                ...this.query,
                ...this.formInline,
                pageNum: this.query.current,
                warehouseCode: this.$store.getters.getWareCode,
            }
            oneServiceTaskPage(params).then((res) => {
                if (res.code == 0) {
                    this.dataSource = res.data.records
                    this.query.total = res.data.total
                }
            })
        },
        download(record) {
          oneServiceDownloadExportData({ taskId: record.id }).then(res => {
            console.log(res);
            if (res.data) {
              window.open(res.data);
            }
          });
        },
        downFailData(){
          oneServiceDownloadImportFailData({ taskId: record.id }).then(res => {
            console.log(res);
            if (res.data) {
              window.open(res.data);
            }
          });
        }
    },
};
</script>
  
<style scoped lang="less">
.ellipsis{
  overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

</style>
  